module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-double-down-f99d4b51.svg";